import { H2RInput } from "../../imports";
import { H2RCheckbox } from "../../imports";
import { H2RSelect } from "../../imports";
import { imageTypesDefinitions } from "../../imports";
import { ImagePreview } from "../FormElements";
import {
	ReplaceWithDataSource,
} from "../helpers/variable";
import { useSelector } from "react-redux";

export const GraphicEditor = ({ cue, media, onUpdate, encode = true }) => {
	const cloud = useSelector((state) => state.rundown.cloud);
	return (
		<>
			<H2RInput
				label="First line (Large text)"
				value={cue.line_one}
				onChange={(value) => {
					onUpdate({
						line_one: value,
					});
				}}
			/>
			<H2RInput
				label="Second line (Small text)"
				value={cue.line_two}
				onChange={(value) => {
					onUpdate({
						line_two: value,
					});
				}}
			/>
			{!cloud && (
				<H2RCheckbox
					checked={cue.useCustomImage || false}
					label="Custom background image"
					hint={cue.useCustomImage && "Tip: Use a 16x9 PNG for best results."}
					checkboxLabel={
						cue.useCustomImage ? "Yes, use custom image" : "No background image"
					}
					onChange={(change) => {
						if (cue.position === "bl" || cue.position === "br") {
						} else {
							if (change === true) {
								onUpdate({ position: "bl" });
							}
						}
						onUpdate({ useCustomImage: change });
					}}
				/>
			)}
			{cue.useCustomImage && (
				<>
					<H2RSelect
						selected={cue.customImage}
						label="Background image"
						options={
							media.length === 0
								? [
										{
											label: "Add images in the Media tab",
											value: ``,
											disabled: true,
										},
								  ]
								: [
										...media
											.filter((item) =>
												imageTypesDefinitions.includes(item.mimetype)
											)
											.filter((item) => !item.partOf)
											.map((item) => {
												return {
													label: item.originalname,
													value: item.filename,
												};
											}),
								  ]
						}
						onChange={(value) => {
							onUpdate({ customImage: value });
						}}
					/>
					<ImagePreview image={cue.customImage} />
				</>
			)}
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div className="overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<div className="font-semibold ">
				{<ReplaceWithDataSource text={cue.line_one} keepBrakets={true} styled={true} /> ||
					"Lower third"}{" "}
			</div>
			<div
				className={`text-xs text-gray-300
                ${twoLines ? "pl-0 block " : ""}
                `}
			>
				{<ReplaceWithDataSource text={cue.line_two} keepBrakets={true} styled={true} />}
			</div>
		</div>
	);
};
